var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.937 12.255-1.315 2.009a8.8 8.8 0 0 1-.235 8.23H8.58a8.8 8.8 0 0 1-1.084-5.347 8.75 8.75 0 0 1 2.27-4.95 8.5 8.5 0 0 1 4.726-2.594 8.43 8.43 0 0 1 5.317.784l1.977-1.336a10.55 10.55 0 0 0-6.78-1.669 10.6 10.6 0 0 0-6.347 2.939 10.92 10.92 0 0 0-3.211 6.293 11 11 0 0 0 1.294 6.967c.187.328.455.6.777.791.322.19.688.292 1.061.295h14.798a2.1 2.1 0 0 0 1.073-.29c.326-.19.597-.465.786-.796a11 11 0 0 0 1.427-5.71c-.05-2-.645-3.948-1.716-5.627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.477 19.682a2.14 2.14 0 0 0 1.511.637 2.1 2.1 0 0 0 1.512-.637l6.047-9.22-9.07 6.147a2.18 2.18 0 0 0-.627 1.537 2.2 2.2 0 0 0 .627 1.536"
  }))));
};
export { SvgSpeed as ReactComponent };